<template>
    <EditModal
        :id="id"
        title="Vertrag anpassen"
        size="xl"
        buttonText="Speichern"
        scrollable
        :busy="busy"
        @show="fetch"
        @ok="dataProvide"
    >
        <b-row>
            <b-button
                variant="warning"
                class="ml-auto mr-3 mb-1"
                size="sm"
                @click="dataReset"
            >Zurücksetzen</b-button>
        </b-row>
        <ckeditor :editor="editor.mode" v-model="editor.data" :config="editor.config" />
    </EditModal>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory";
import Toaster from "@/mixins/Toaster/Toaster";
import EditModal from "@/components/EditModal/EditModal";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const PDFTemplateApi = ApiFactory.get("templates");

export default {
    name: "TemplateDialog",
    components: {
        EditModal
    },
    mixins: [Toaster],
    props: ["label"],
    data() {
        return {
            id: "templateDialog",
            busy: false,
            editor: {
                mode: ClassicEditor,
                data: "<i>Templatedaten werden geladen...</i>",
                default: "",
                config: {
                    toolbar: {
                        items: [
                            "bold",
                            "italic",
                            "underline",
                            "strikethrough",
                            "|",
                            "undo",
                            "redo",
                            "cleanup"
                        ]
                    }
                }
            }
        };
    },
    methods: {
        async fetch() {
            if (this.label) {
                const response = await PDFTemplateApi.get(this.label);
                if (response.ok) {
                    const editor = Object.assign(this.editor, {
                        data: response.json.content,
                        default: response.json.default
                    });
                    this.editor = editor;
                }
            }
        },
        async dataReset() {
            const editor = Object.assign(this.editor, {
                data: this.editor.default
            });
            this.editor = editor;
        },
        async dataProvide(evt) {
            evt.preventDefault();
            this.busy = true;
            const response = await PDFTemplateApi.put(this.label, {
                content: this.editor.data
            });
            if (response.ok) {
                this.makeToast(
                    "Erfolgreich gespeichert",
                    "Die Vertragsänderung ist erfolgreich gespeichert worden"
                );
                this.$root.$emit("bv::hide::modal", this.id);
            } else {
                this.makeToast(
                    "Fehler",
                    "Die Vertragsänderung konnte nicht gespeichert werden",
                    "danger"
                );
            }
            this.busy = false;
        }
    }
};
</script>